import React from "react";
import './PopContent.scss'

const PopContent = (props) => {

    const {refObj, content, children,correct} = props

    return (
        <>
            <div ref={refObj} className={`pop-content-orbit ${correct? 'correct' : 'wrong'}`} style={{
                top: `${content.pos.y}px`,
                left: `${content.pos.x}px`,
            }} >
                {!content.title &&
                <div className={`header ${correct? 'correct' : 'wrong'}`}>
                    {correct? <p>That's Right</p>:<p>Oh No!</p>}
                </div>
                }
                <div className={'body'}>
                    {content.title && <h2>{content.title}</h2> }
                    <p>{content.feedback}</p>
                    {children}
                </div>
            </div>
        </>
    );
}

export default PopContent;
